// Hazardous Substances reuses the unified document editor (GeneralApp) with the
// 'hazards' docType, so it behaves like every other document type (rich-text
// sections, reorder, PDF export) instead of the old single link field.
import GeneralApp from './index';

export default function HazardousSubstances() {
  return <GeneralApp type="hazards" />;
}
